import { merchantApi } from '@/config/axios'

export interface O2oReviewMerchantPageReqVO {
  pageNo: number
  pageSize: number
  tab?: string
  orderId?: number
  providerId?: number
  serviceId?: number
  minScore?: number
  maxScore?: number
  status?: string
}

export interface O2oReviewReplyItemVO {
  content?: string
  replyTime?: string
  source?: string
  institutionName?: string
}

export interface O2oReviewMerchantVO {
  id: number
  orderId?: number
  orderNo?: string
  userNickname?: string
  providerId?: number
  providerName?: string
  serviceId?: number
  serviceName?: string
  overallScore?: number
  content?: string
  ratingsJson?: Record<string, number>
  images?: string[]
  tags?: string
  anonymous?: boolean
  status?: string
  replyContent?: string
  replyTime?: string
  replied?: boolean
  institutionName?: string
  replies?: O2oReviewReplyItemVO[]
  createTime?: string
}

export function getO2oMerchantReviewPage(params: O2oReviewMerchantPageReqVO) {
  return merchantApi.get<{ list: O2oReviewMerchantVO[]; total: number }>({
    url: '/merchant-api/o2o/review/page',
    params
  })
}

export function getO2oMerchantReview(id: number) {
  return merchantApi.get<O2oReviewMerchantVO>({
    url: '/merchant-api/o2o/review/get',
    params: { id }
  })
}

export function replyO2oMerchantReview(data: { id: number; replyContent: string }) {
  return merchantApi.put<boolean>({
    url: '/merchant-api/o2o/review/reply',
    data
  })
}
